<p>
  A Save effect forces a targeted creature to make a saving throw.
  <avr-autodoc-link anchor="save"></avr-autodoc-link>
</p>

<!-- stat -->
<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center" class="auto-row">
  <mat-form-field>
    <mat-label>Save Stat</mat-label>
    <mat-select [(value)]="effect.stat" (selectionChange)="changed.emit()">
      <mat-option value="str">Strength</mat-option>
      <mat-option value="dex">Dexterity</mat-option>
      <mat-option value="con">Constitution</mat-option>
      <mat-option value="int">Intelligence</mat-option>
      <mat-option value="wis">Wisdom</mat-option>
      <mat-option value="cha">Charisma</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- dc -->
<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center" class="auto-row">
  <mat-checkbox matTooltip="If not checked, uses the caster's default DC."
                [(ngModel)]="custom"
                (change)="changed.emit(); onCustomChange()"
                *ngIf="spell != null">
    Has custom DC
  </mat-checkbox>
  <mat-form-field fxFlex="grow" *ngIf="custom">
    <input matInput placeholder="DC" class="text-monospace" (change)="changed.emit()" [(ngModel)]="effect.dc">
    <mat-icon matSuffix matTooltip="IntExpression - variables and functions allowed">
      calculate
    </mat-icon>
  </mat-form-field>
</div>

<!-- advantage -->
<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center" class="auto-row">
  <mat-form-field matTooltip="The default advantage for this saving throw.">
    <mat-label>Advantage</mat-label>
    <mat-select [(value)]="advantageWrapper" (selectionChange)="changed.emit()">
      <mat-option [value]="0">Flat</mat-option>
      <mat-option [value]="1">Advantage</mat-option>
      <mat-option [value]="-1">Disadvantage</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<p>
  Use the Effect Tree to edit the on-fail and on-success effects!
</p>
